var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3334 28.6676H8.00004C5.42271 28.6676 3.33337 26.5783 3.33337 24.0009V6.59185C3.33337 5.16844 4.74116 4.26605 5.97991 4.69612C6.15687 4.75756 6.33038 4.84619 6.49585 4.96438L6.72925 5.13109C7.88661 5.95778 9.45193 5.95412 10.6125 5.1251C12.2351 3.96611 14.4316 3.96611 16.0542 5.1251C17.2148 5.95412 18.7801 5.95778 19.9375 5.13109L20.1709 4.96438C21.4946 4.01885 23.3334 4.9651 23.3334 6.59185V16.6676H28C28.5523 16.6676 29 17.1153 29 17.6676V25.0009C29 27.026 27.3584 28.6676 25.3334 28.6676ZM23.6667 18.6676V25.0009C23.6667 25.9214 24.4129 26.6676 25.3334 26.6676C26.2538 26.6676 27 25.9214 27 25.0009V18.6676H23.6667ZM18 13.0009C18 12.4486 17.5523 12.0009 17 12.0009H9.00004C8.44776 12.0009 8.00004 12.4486 8.00004 13.0009C8.00004 13.5532 8.44776 14.0009 9.00004 14.0009H17C17.5523 14.0009 18 13.5532 18 13.0009ZM16.6667 17.0009C16.6667 16.4486 16.219 16.0009 15.6667 16.0009H9.00004C8.44776 16.0009 8.00004 16.4486 8.00004 17.0009C8.00004 17.5532 8.44776 18.0009 9.00004 18.0009H15.6667C16.219 18.0009 16.6667 17.5532 16.6667 17.0009ZM17 20.0009H9.00004C8.44776 20.0009 8.00004 20.4486 8.00004 21.0009C8.00004 21.5532 8.44776 22.0009 9.00004 22.0009H17C17.5523 22.0009 18 21.5532 18 21.0009C18 20.4486 17.5523 20.0009 17 20.0009Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.4b5eb664c7907638427a3f820373c364.svg";
export { ForwardRef as ReactComponent };